import { championSlugsToNames } from "@data/constants/championsConstants"
import React from "react"
import { View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import mealsImage from "../../../assets/icons/generic/lunch-bag.png"
import treesImage from "../../../assets/icons/generic/tree.png"
import ranking from "../../../assets/icons/menus/ranking.png"
import TouchableRippleM from "../../common/components/button/TouchableRippleM"
import { ProgressBarM } from "../../common/components/progress/ProgressBarM"
import { StatisticsItem } from "../../common/components/statistics/StatisticsItem"
import TextM from "../../common/components/text/TextM"
import { theme } from "../../common/theme/theme"
import { apiIdle, apiRequest } from "../../data/redux/actions/api"
import { formatFrenchDe } from "./SkillSetTitleButton"

const getCalculatedColor = (variant, skillSet = null) => {
    if (variant === "quest") {
        return skillSet?.color + "10"
    }

    return null
}

const AccountProgression = (props) => {
    const { onPress, variant, title, disabled, style, skillSet, color } = props

    const calculatedColor =
        getCalculatedColor(variant, skillSet) ??
        color ??
        theme.colors.whiteAlmost

    const renderVariantSection = () => {
        const countTreesPurchases = props.user?.shop_purchases?.filter(
            (p) => p?.shop_product_id === 1
        )?.length
        const countMealsPurchases = props.user?.shop_purchases?.filter(
            (p) => p?.shop_product_id === 2
        )?.length

        switch (variant) {
            case "quest":
                return (
                    <View
                        style={{
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <TextM
                            color={skillSet?.color}
                            style={{}}
                            fontWeight="Bold"
                            fontSize={12}
                        >
                            {(
                                "Quête " +
                                formatFrenchDe(
                                    championSlugsToNames?.[
                                        skillSet?.champion
                                    ] ?? ""
                                )
                            ).toUpperCase()}{" "}
                            {skillSet?.current_step}/{skillSet?.steps?.length}
                        </TextM>

                        {skillSet?.current_step && <ProgressBarM
                            progressColor={skillSet?.color}
                            previousCount={0}
                            canStartAnimation={false}
                            withAnimation={false}
                            count={skillSet?.current_step ?? 0}
                            total={skillSet?.steps?.length ?? 0}
                            noText
                        />}
                    </View>
                )

            case "ranking":
                return (
                    <View
                        style={{
                            flex: 1,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <StatisticsItem
                            source={ranking}
                            color={theme.colors.errorDark}
                            count={props.user?.rank}
                            width={"100%"}
                        />
                    </View>
                )

            case "shop":
                return (
                    <View
                        style={{
                            flex: 1,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <StatisticsItem
                            source={treesImage}
                            color={theme.colors.petalDarker}
                            count={countTreesPurchases}
                            width={"50%"}
                        />

                        <StatisticsItem
                            source={mealsImage}
                            color={theme.colors.petalDarker}
                            count={countMealsPurchases}
                            width={"50%"}
                        />
                    </View>
                )

            default:
                return null
        }
    }

    return (
        <TouchableRippleM
            onPress={onPress}
            disabled={disabled}
            style={{
                flexDirection: "row",
                borderColor: theme.colors.lightMore,
                paddingVertical: 16,
                paddingHorizontal: 16,
                alignItems: "center",
                justifyContent: "space-between",
                height: 80,
                width: "100%",
                backgroundColor: calculatedColor,
                overflow: "hidden",
                ...style,
            }}
        >
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        flex: 1,
                    }}
                >
                    <View style={{ marginLeft: 8, flex: 1 }}>
                        <TextM
                            fontWeight={"Bold"}
                            color={theme.colors.primary}
                            wrap
                            fontSize={18}
                        >
                            {title}
                        </TextM>
                    </View>
                </View>

                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        maxWidth: "50%",
                    }}
                >
                    {renderVariantSection()}
                    <FontAwesome5
                        name={"chevron-right"}
                        solid
                        size={24}
                        color={theme.colors.primary}
                        style={{
                            marginLeft: 20,
                        }}
                    />
                </View>
            </View>
        </TouchableRippleM>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        skills: state.data.staticData?.skills,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountProgression)
